import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import AdminManagement from "views/admin/marketplace";
import DataTables from "views/admin/tables";
import Payment from "views/admin/payment_admin";
import RunnerBoysManagement from "views/admin/runnerboys";
import ServicesManagement from "views/admin/Services";
import ServiceDetails from "views/admin/Services/ServiceDetails";
import { ServicesProvider } from "views/admin/Services/ServicesContext";
import Profile from "views/admin/profile";
import UserDetails from "views/admin/user_profile/user_details";
// Icon Imports
import {
  MdHome,
  MdPeople,
  MdBarChart,
  MdPerson,
  MdDeliveryDining,
  MdLocalLaundryService,
  MdPayment,
} from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    roles: ["SA", "A", "R"],
  },
  {
    name: "Admin Management",
    layout: "/admin",
    path: "admins",
    icon: <MdPeople className="h-6 w-6" />,
    component: <AdminManagement />,
    roles: ["SA"],
  },
  {
    name: "Runner Boys",
    layout: "/admin",
    icon: <MdDeliveryDining className="h-6 w-6" />,
    path: "runner-boys",
    component: <RunnerBoysManagement />,
    roles: ["SA", "A"],
  },
  {
    name: "Bookings",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "bookings",
    component: <DataTables />,
    roles: ["SA", "A", "R"],
  },
  {
    name: "Transactions",
    layout: "/admin",
    icon: <MdPayment className="h-6 w-6" />,
    path: "payment",
    component: <Payment />,
    roles: ["SA", "A"],
  },
  {
    name: "Services",
    layout: "/admin",
    icon: <MdLocalLaundryService className="h-6 w-6" />,
    path: "services",
    component: (
      <ServicesProvider>
        <ServicesManagement />
      </ServicesProvider>
    ),
    roles: ["SA", "A"],
  },
  {
    layout: "/admin",
    path: "services/:serviceId",
    component: (
      <ServicesProvider>
        <ServiceDetails />
      </ServicesProvider>
    ),
    invisible: true,
    roles: ["SA", "A"],
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    roles: ["SA", "A", "R"],
  },
  {
    name: "User Details",
    layout: "/admin",
    path: "user-details",
    component: <UserDetails />,
    roles: ["SA", "A"],
  },
];

export default routes;
